import { render, staticRenderFns } from "./CompleteSignup.vue?vue&type=template&id=36f813af&scoped=true&"
import script from "./CompleteSignup.vue?vue&type=script&lang=js&"
export * from "./CompleteSignup.vue?vue&type=script&lang=js&"
import style0 from "./CompleteSignup.vue?vue&type=style&index=0&id=36f813af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f813af",
  null
  
)

export default component.exports